// i18n area 'networks' — locale hr-HR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.hr-HR.meta.json.
import type { enUS } from './networks'

export const hrHR: typeof enUS = {
  networks: {
    common: {
      name: 'Naziv',
      scope: 'Scope',
      operState: 'Stanje',
      actions: 'Radnje',
      create: 'Stvori',
      close: 'Zatvori',
      cancel: 'Odustani',
      delete: 'Izbriši',
      edit: 'Uredi',
      save: 'Spremi',
      editError: 'Uređivanje nije uspjelo',
      search: 'Pretraži po nazivu',
      empty: 'Ovdje još nema ničega',
      saveError: 'Spremanje nije moguće',
      loadError: 'Učitavanje nije moguće — je li TVirt backend dostupan?',
      createError: 'Stvaranje nije uspjelo',
      deleteError: 'Brisanje nije uspjelo',
      deleteConfirmTitle: 'Izbrisati {name}?',
      deleteConfirmBody: 'Ova se radnja ne može poništiti.',
      nameHint: 'Mala slova, znamenke i crtice (DNS-1123)',
      up: 'Aktivna',
      down: 'Neaktivna',
      unknown: 'Nepoznato',
      usedByVMs: 'VM-ovi',
      emptyTable: 'Nema stavki — dodajte jednu gumbom +'
    },
    dialogTabs: {
      general: 'Općenito',
      base: 'Osnovna definicija',
      advanced: 'Napredna konfiguracija',
      reserved: 'Rasponi rezervirani za TVirt',
      position: 'Položaj',
      network: 'Mrežna konfiguracija',
      hosts: 'Sudjelujući čvorovi'
    },
    reservedRanges: {
      note: 'Ovo su rasponi IP adresa rezervirani za TVirt koje može koristiti za automatsku dodjelu adrese VM-ovima, kontejnerima itd. NAPOMENA: adrese iz ovih raspona ne smiju izvan TVirta koristiti vanjske usluge ili uređaji.',
      from: 'Od',
      to: 'Do'
    },
    overlay: {
      title: 'Overlay mreže',
      createTitle: 'Stvori overlay mrežu',
      editTitle: 'Uredi overlay mrežu',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — dodjeljuje se automatski ako je prazno',
      subnet: 'Podmreža',
      subnetHint: 'CIDR overlay mreže — IPAM iz njega automatski izvodi stavku registra',
      mtu: 'MTU',
      weight: 'Težina',
      ceilMbps: 'Gornja granica (Mbps)',
      fairnessHint: 'Težina vrijedi samo pri zagušenju: na slobodnoj vezi svaka mreža može koristiti svu propusnost. Gornja granica vrijedi uvijek.',
      contention: 'Natjecanje',
      contentionTip: 'Barem jedan čvor bilježi odbacivanja ili overlimite S redom čekanja na klasi ove mreže: propusnost uplinka je osporavana i težine djeluju. Koliko i otkad piše u serijama net.shaping.* čvora.',
      firewallPolicy: 'Politika vatrozida',
      hosts: 'Hostovi',
      hostsTitle: 'Sudjelujući čvorovi',
      hostsHint: 'Svaki čvor deklarira svoj underlay endpoint — select nad STVARNIM adresama čvora, pročitanima iz njegove mrežne konfiguracije; neobavezna overlay adresa mora biti unutar podmreže. Sudjelovanje je ograničenje placementa.',
      hostNode: 'Čvor',
      hostUnderlay: 'Underlay IP',
      hostUnderlayPickNode: 'Najprije odaberite čvor',
      hostAddress: 'Adresa na overlayu (neobavezno)',
      hostAddressOutside: 'Izvan podmreže overlaya ({cidr})',
      addHost: 'Dodaj čvor',

      observedAt: 'Opaženo',
      attachedNics: 'Priključeni NIC-ovi'
    },
    services: {
      title: 'Mrežne usluge',
      createTitle: 'Stvori mrežnu uslugu',
      editTitle: 'Uredi mrežnu uslugu',
      kind: 'Vrsta',
      kindCategory: 'Usluge',
      selectKindHint: 'Odaberite vrstu usluge — daemon u pozadini implementacijski je detalj kojim TVirt upravlja za vas.',
      kindLabel: {
        dhcp: 'DHCP poslužitelj',
        ntp: 'NTP poslužitelj',
        vpn: 'VPN poslužitelj',
        dns: 'DNS poslužitelj',
        gateway: 'Pristupnik',
        'lb-rp': 'Load balancer i reverse proxy',
        floatip: 'Plutajući IP'
      },
      kindDesc: {
        dhcp: 'Dodjeljuje adrese na posluživanim podmrežama — poolovi se izvode iz podmreže, pristupnika i raspona rezerviranih za TVirt te mreže.',
        dns: 'Autoritativni DNS nad deklariranim zonama — zapisi se izvode iz IPAM-a, uz vaše ručne.',
        gateway: 'Čvor djeluje kao pristupnik za mrežu — NAT (DNAT, 1:1, SNAT/masquerade) uz statičko usmjeravanje između priključenih mreža, samoobnavljajuće po dizajnu.',
        'lb-rp': 'Balanser / obrnuti proxy ispred vaših usluga — L4 ili L7 slušatelji nad poolovima članova ili nad spremnim instancama Poda, rekonfigurirani u letu.',
        ntp: 'Vremenska usluga mreža — relay vanjskih upstream poslužitelja ili sat samog čvora posluživan klijentima.',
        vpn: 'VPN koncentrator na čvoru — WireGuard ili OpenVPN, po vašem izboru: udaljeni pristup za klijente u pokretu ili site to site tunel između dviju mreža.',
        floatip: 'Jedna adresa koja sjedi na samo jednoj zdravoj App instanci ili Podu odjednom i seli se na sljedeći zdravi cilj kad on padne — failover bez demona; balansiranje ostaje balanseru.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Plutajući IP živi na odabranoj mreži kao DODATNA adresa unutar imenskog prostora instance koja ga drži: bez portova, bez balansiranja, bez NAT-a — IP klijenta ostaje pravi.',
        address: 'Plutajući IP',
        targets: 'Ciljevi',
        targetsHint: 'Redoslijedom PREFERENCIJE: prvi zdravi cilj drži adresu. Pod vrijedi za sve svoje instance, po replici; svaki cilj ima vlastiti kriterij zdravlja. Svaki cilj mora biti spojen na istu mrežu.',
        targetKind: 'Cilj',
        targetApp: 'App instanca',
        targetPod: 'Pod (sve instance)',
        targetRef: 'Koji',
        health: 'Zdravlje',
        healthRunning: 'Radi (svaki kontejner spreman)',
        healthTcp: 'TCP veza',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Port',
        path: 'Putanja',
        addTarget: 'Dodaj cilj',
        moveUp: 'Pomakni gore',
        moveDown: 'Pomakni dolje',
        preempt: 'Preempt',
        preemptHint: 'Isključeno (zadano): zdravi držatelj zadržava adresu i kad se viši cilj vrati — bez preskakanja. Uključeno: prvi zdravi cilj uvijek je drži.',
        holder: 'Držatelj',
        noHolder: 'nema zdravog cilja',
        since: 'od',
        verdicts: 'Promatrani ciljevi',
        healthy: 'zdrav',
        unhealthy: 'nezdrav',
        noVerdict: 'Još nije odlučeno — čvor autoriteta zapisuje prvu presudu u sljedećem prolazu.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Ova instanca drži plutajući IP {address} usluge {service}'
      },
      poolSource: 'Krajnje točke',
      poolSourceMembers: 'Statički članovi',
      poolSourcePod: 'Spremne instance Poda',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Port',
      poolBackendHint: 'Krajnje točke prate Pod: instanca ulazi kad radi sa svakim kontejnerom spremnim, izlazi odmah kad se smanji ili umre. Aktivna provjera zadano je uključena.',
      poolBackendCount: 'spremne instance Poda {pod} na portu {port}',
      node: 'Čvor',
      enabled: 'Omogućeno',
      parked: 'Parkirano',
      subnets: 'Podmreže',
      subnetsHint: 'IPAM podmreže koje ova instanca poslužuje — poolovi se izvode iz CIDR-a, pristupnika i raspona rezerviranih za TVirt',
      noSubnets: 'Još nema IPAM podmreža — najprije deklarirajte logičku mrežu fabrica (ili overlay podmrežu): IPAM se izvodi iz njih',
      iface: 'Sučelje za slušanje',
      ifaceHint: 'Sučelje hosta na kojem usluga otvara svoj socket (npr. bridge) — obavezno: mrežna usluga je samodostatna, "sva sučelja" više ne postoje',
      dns: 'DNS poslužitelji',
      domain: 'Domena',
      detail: 'Poslužuje',
      subnetCount: 'podmreža: {n}',
      zones: 'Zone',
      zonesHint: 'Samo autoritativno — daemon nikad ne obavlja rekurziju. A zapisi izvode se iz deklariranih adresa čvorova u referenciranim IPAM podmrežama; prekidač reverse poslužuje i odgovarajuće in-addr.arpa zone (PTR). Zonu poslužuje najviše jedna DNS instanca na razini flote. Neobavezni nameserver je FQDN upisan u NS/SOA zapise umjesto zadanog ns.<zona>; padne li unutar zone, njegov A zapis svejedno se izvodi iz čvora koji poslužuje.',
      zoneName: 'Naziv zone',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'IPAM podmreže',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Ručni zapisi',
      zoneRecordsHint: 'Jedan po retku: naziv TIP vrijednost — tipovi A, CNAME, MX, TXT. Pri koliziji naziva ručni zapis pobjeđuje izvedeni.',
      addZone: 'Dodaj zonu',

      lbListeningHint: 'Instanca deklarira JEDNU mrežu za slušanje i JEDNU adresu — svaki je listener veže na vlastitom portu; druga adresa znači drugu uslugu.',
      listeners: 'Listeneri',
      listenersHint: 'Svaki listener veže adresu instance na vlastitom portu u načinu L4 (TCP passthrough — bajtovi se nikad ne otvaraju) ili L7 (HTTP) i prosljeđuje jednom od poolova u nastavku. Par adresa/port poslužuje najviše jedna instanca po čvoru. Izmjene se primjenjuju u hodu — bez ponovnog pokretanja, bez izgubljenih veza.',
      listenerName: 'Naziv',
      listenerMode: 'Način',
      modeL7: 'L7 — HTTP reverse proxy',
      modeL4: 'L4 — TCP passthrough',
      listenerPort: 'Port',
      listenerPool: 'Pool',
      addListener: 'Dodaj listener',
      pools: 'Poolovi',
      poolsHint: 'Backendi na koje slijeće promet: statički članovi balansirani round-robin ili prema najmanje zauzetom, s neobaveznim aktivnim health checkom koji bolesne članove izbacuje iz rotacije.',
      poolName: 'Naziv',
      poolAlgorithm: 'Algoritam',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Najmanje zauzet',
      poolCheck: 'Health check',
      checkNone: 'Nijedan',
      checkTcp: 'TCP veza',
      checkHttp: 'HTTP',
      poolCheckPath: 'Putanja sonde',
      poolInterval: 'Interval (s)',
      poolMembers: 'Članovi',
      poolMembersHint: 'Jedan po retku: adresa:port, po želji s težinom (1-128) — npr. 10.0.0.21:8080 2',
      addPool: 'Dodaj pool',
      memberCount: 'članova: {n}',

      listen: {
        assignment: 'Dodjela',
        assignmentStatic: 'Statička adresa',
        assignmentAuto: 'Automatska (TVirt rezervirani rasponi)',
        autoHint: 'TVirt izvlači adresu iz rezerviranih raspona logičke mreže i drži je sticky — nikad ponovno izvučena pri uređivanju ili failoveru.',
        title: 'Listeneri',
        hint: 'Mrežna usluga je samodostatna: svaki listener deklarira svoju mrežu (overlay, logičku mrežu fabrica ili sučelje) i adresu unutar njezine podmreže — jedan listener po adresi, wildcard više ne postoji. DNS i NTP mogu slušati na više mreža i na više adresa tih mreža.',
        address: 'Adresa za slušanje',
        add: 'Dodaj listener'
      },
      ntp: {
        mode: 'Način sinkronizacije',
        modeRelay: 'Relay vanjskih poslužitelja',
        modeNodeClock: 'Sat čvora',
        modeHint: 'Relay poslužuje vrijeme preuzeto s deklariranih upstream poslužitelja; sat čvora poslužuje vrijeme čvora koji poslužuje — koje klaster ionako drži sinkroniziranim',
        servers: 'Upstream poslužitelji',
        serversHint: 'Odvojeni zarezom — hostname ili IP adresa; usluga odavde preuzima vrijeme i poslužuje ga mreži',
        port: 'Port za slušanje',
        listening: 'Sluša na'
      },

      vpn: {
        engine: 'Pogon',
        engineHint: 'Birate ga vi i više se ne mijenja: WireGuard je moderan, brz i in-kernel; OpenVPN je veteran kompatibilnosti (TCP, restriktivne mreže)',
        engineLocked: 'Pogon je nepromjenjiv — drugi pogon znači novu uslugu, ključevi i certifikati nisu prenosivi',
        mode: 'Način',
        modeRemote: 'Udaljeni pristup',
        modeSite: 'Site to site',
        modeHint: 'Udaljeni pristup klijentima u pokretu daje adresu u tunelu; site to site spaja dvije mreže',
        port: 'Port za slušanje',
        protocol: 'Transport',
        protocolWireguardHint: 'WireGuard govori samo UDP',
        tunnelSubnet: 'Podmreža tunela',
        tunnelSubnetHint: 'Mreža u kojoj žive klijenti — upisana u IPAM registar, nastaje i umire s ovom uslugom',
        dnsServers: 'DNS gurnuti klijentima',
        routes: 'Rute gurnute klijentima',
        routesHint: 'Zarezom odvojene mreže dostupne kroz tunel; podmreža tunela uvijek je uključena',
        peers: 'Peerovi',
        peersHint: 'Ostavite javni ključ praznim i TVirt generira par — potom ga isporučuje s profilom. Zalijepite ključ i peer zadržava svoj.',
        clients: 'Klijenti',
        clientsHint: 'Svaki klijent dobiva certifikat koji izdaje CA ove usluge. Uklanjanje klijenta ga OPOZIVA: CRL se odmah regenerira.',
        peerName: 'Naziv',
        publicKey: 'Javni ključ',
        publicKeyMinted: 'Generira ga TVirt',
        peerAddress: 'Adresa u tunelu',
        peerAddressHint: 'Prazno = dodijeljeno',
        allowedIps: 'Udaljene podmreže',
        allowedIpsHint: 'Odvojene zarezom, usmjerene kroz ovaj peer',
        endpoint: 'Endpoint',
        presharedKey: 'Unaprijed dijeljeni ključ',
        keepalive: 'Keepalive (s)',
        addPeer: 'Dodaj peer',
        addClient: 'Dodaj klijenta',
        auth: 'Autentifikacija',
        authTls: 'Certifikati (TLS)',
        remote: 'Udaljeni endpoint',
        remoteHint: 'host:port udaljenog kraja — prazno znači da ova strana čeka',
        peerRoutes: 'Udaljene podmreže',
        serverPublicKey: 'Javni ključ ovog poslužitelja',
        ca: 'Certifikacijsko tijelo',
        listening: 'Sluša na',
        tunnel: 'Tunel',
        peerCount: 'peerova: {n}',
        download: 'Preuzmi profil',
        downloadError: 'Profil nije bilo moguće izvesti',
        lastHandshake: 'Zadnji handshake',
        never: 'nikad',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Povezan',
        idle: 'U mirovanju'
      },

      gateway: {
        attach: 'Vrsta listening mreže',
        attachOverlay: 'Overlay mreža',
        attachNetwork: 'Logička mreža fabrica',
        attachInterface: 'Sirovo sučelje',
        overlay: 'Overlay mreža',
        network: 'Logička mreža',
        interface: 'Naziv sučelja',
        interfaceHint: 'Sučelje hosta kojim TVirt ne upravlja — adresa se uzima na povjerenje',
        address: 'Listening adresa (pristupnik)',
        addressHint: 'Adresa pristupnika na koju pokazuju klijenti — unutar podmreže listening mreže',
        dnatTitle: 'DNAT pravila',
        dnatHint: 'Odredišni NAT: promet obuhvaćen matchom preusmjerava se na novu adresu (i po želji novi port). Bilo koji protokol s popisa — portovi ondje gdje ih protokol nosi.',
        snatTitle: 'SNAT pravila',
        snatHint: 'Izvorišni NAT: promet obuhvaćen matchom izlazi s prepisanim izvorom — eksplicitna nova adresa (i po želji novi port) ili masquerade na izlaznoj adresi ako se ostavi prazno.',
        oneToOneTitle: '1:1 NAT pravila',
        oneToOneHint: 'Svaki paket za vanjsku adresu preslikava se na unutarnju, a unutarnji host izlazi kao vanjska — svi protokoli, oba smjera.',
        external: 'Vanjska adresa',
        internal: 'Unutarnja adresa',
        addOneToOne: 'Dodaj 1:1 pravilo',
        family: 'Obitelj',
        protocol: 'Protokol',
        source: 'Izvor (adresa/podmreža)',
        destination: 'Odredište (adresa/podmreža)',
        invert: 'NOT',
        srcPorts: 'Izvorišni portovi',
        dstPorts: 'Odred. portovi',
        dstPortsHint: 'Port ili raspon (80, 8000-8099)',
        toAddress: 'Nova adresa',
        toPort: 'Novi port',
        snatTo: 'Novi izvor (prazno = masquerade)',
        snatToHint: 'Eksplicitna izvorišna adresa; prazno = masquerade na izlaznoj adresi',
        addDnat: 'Dodaj DNAT pravilo',
        addSnat: 'Dodaj SNAT pravilo',
        routesTitle: 'Statičke rute',
        routesHint: 'Čvor usmjerava između mreža na koje je priključen (IP forwarding je uključen); ove rute dodaju dostupnost izvan njih — čisti kernel, dinamičko usmjeravanje stiže s kasnijom rundom.',
        routeDestination: 'Odredišna podmreža',
        routeGateway: 'Next hop',
        routeMetric: 'Metrika',
        addRoute: 'Dodaj rutu',
        listening: 'Sluša na',
        rules: 'DNAT: {d} · 1:1: {o} · SNAT: {s} · ruta: {r}'
      },
      unknownSince: 'Nepoznato — zadnji report prije {m} min',
      lastWord: 'Zadnja riječ',

      reportObservedAt: 'Zadnji report',
      lastErrorRow: 'Zadnja pogreška',
      recordsCount: 'ručnih zapisa: {n}',
      phase: {
        configured: 'Konfigurirano',
        running: 'Pokrenuto',
        error: 'Pogreška'
      },
      authorityNode: 'Authority (dodjela)',
      preferredNode: 'Preferirani čvor',
      preferredNodeHint: 'Meka preferencija, nikad ograničenje: pri sljedećoj odluci o placementu instanca slijeće ovdje ako je taj član podoban — sama po sebi ništa ne pomiče; potez je "Prenesi authority".',
      noPreference: 'Bez preferencije (automatski placement)',
      moving: 'U pokretu',
      movingTooltip: 'Promatrana ovdje dok authority dodjeljuje {node}: potez upravo konvergira.',
      placement: {
        title: 'Placement',
        loading: 'Popis u tijeku…',
        loadError: 'Popis placementa nije odgovorio — pokušajte kasnije.',
        draftHint: 'Popis se računa iz deklariranog mrežnog priključka: pojavit će se čim usluga bude stvorena. Stvaranje se odbija kad je nijedan član ne može posluživati, a odbijanje imenuje mehanizam koji je ispraznio skup.',
        eligibleCount: '{n} od {m} članova može posluživati ovu instancu',
        recommended: 'Preporučen',
        eligible: 'Podoban',
        notEligible: 'Nije podoban',
        blockedReachability: 'mreža ne stiže do ovog člana',
        blockedRequireTag: 'blokiran obaveznim tagom (requireNodes)',
        blockedExcluded: 'isključen simulacijom',
        preferenceUnknown: 'nije (više) član klastera',
        preferenceIgnored: 'Preferencija "{node}" danas nije podobna: {reason}. Prevladava preporuka popisa — nikad pogreška, usluga živi drugdje.',
        emptyReachability: 'Nijedan član ne može posluživati ovu instancu: mreža ne stiže nikamo — nikakvo podešavanje tagova neće pomoći. Ožičite čvor ili premjestite uslugu onamo gdje mreže ima.',
        emptyRequireTag: 'Nijedan član ne može posluživati ovu instancu: skup su ispraznili obavezni tagovi — uklonite unos iz requireNodes ili tagirajte nekog člana.',
        spof: 'Jedina točka kvara',
        spofDetail: 'Instancu može ugostiti samo jedan član: pri kvaru failover nema kamo. Usluga s više listenera seli se kao CJELINA — kandidat mora vidjeti SVE njezine mreže: to je cijena.',
        whatIf: 'Simuliraj odsutne članove',
        whatIfHint: 'What-if pražnjenja: pitajte PRIJE evakuacije, ne otkrivajte to tek pri failoveru.',
        survives: 'I bez {nodes} usluga još ima dom.',
        notSurvives: 'Evakuacija {nodes} ostavlja ovu uslugu UGAŠENOM: izvedeno ograničenje pobjeđuje dostupnost (R30) — demon živ ondje gdje mreža ne stiže nikome ne služi i nikoga ne alarmira.',
        transfer: 'Prenesi authority',
        transferError: 'Prijenos nije uspio',
        transferTarget: 'Odredišni član',
        transferHint: 'Nude se samo podobni članovi — preferencija unutar valjanog skupa, nikad override. Nema zadatka: sljedeći prolaz workera JEST potez (stari čvor žanje, novi ostvaruje).'
      }
    },
    fabric: {
      tabDerivation: 'Derivacija',
      importNetwork: 'Uvezi iz drugog fabrica',
      importTitle: 'Uvezi logičku mrežu',
      importHint: 'Uvoz je izričito pristupanje: mreža ostaje vlasnikova (isti identitet, isti stem, isti bridge tvf-<stem>) i odavde se mapira na portove/LAGG ovog fabrica — mapirati ZNAČI tvrditi da isporuka izlazi u istu L2 domenu kao vlasnikova.',
      importPick: 'Vlasnikova mreža',
      importNone: 'Nema što uvesti: drugi fabrici nemaju vlastitu mrežu koju ovaj fabric već ne poznaje',
      importedNetworksTitle: 'Uvezene mreže',
      noImported: 'Nema uvezene mreže',
      importedFrom: 'uvezena iz {fabric}',
      importedBy: 'Uvezena u: {list}',
      importedCount: '+{n} uvezenih',
      owner: 'Vlasnik',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Ukloni uvoz',
      unimportConfirm: 'Ukloniti uvoz mreže {name} (vlasnik {fabric}) iz ovog fabrica? Odbija se dok je port ili LAGG ovog fabrica mapira, ili dok se gost, App ili servis poslužuje samo kroz ovu nogu.',
      unimportRefused: 'Uvoz je još u upotrebi — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Ovaj čvor već uzima tu mrežu iz drugog fabrica čiji je član: čvor uzima dijeljenu mrežu samo s JEDNE svoje noge (dva uplinka istog L2 u bridgeu bez STP-a su petlja). Odmapiraj je na portovima ili LAGG-u jednog od dva fabrica.',
          otherFabricDerived: 'Dokument nosi blok fabrica prema kojem čvor više ne deklarira kabel: prvo primijeni plan tog fabrica (predlaže uklanjanje njegovih uređaja), ili ih preuzmi s take-ownership ako fabric više ne postoji.'
        },
        hint: 'Plan derivacije O.3: za svaki ožičeni čvor stanje, diff izvedeno-vs-trenutno, DEKLARIRANA topologija bondova, dual-stack flipovi i strukturirana odbijanja/upozorenja. Samo za čitanje do EKSPLICITNOG applyja — ništa nikad ne slijeće na čvor samo.',
        refresh: 'Ponovno učitaj plan',
        empty: 'Nijedan čvor nije ožičen na ovaj fabric (i nijedan više ne nosi njegov blok).',
        refusal: 'Odbijanje',
        warning: 'Upozorenje',
        generation: 'generacija dokumenta {n}',
        state: {
          manual: 'Ručni',
          derived: 'Izveden',
          diverged: 'Odstupljen'
        },
        topologyTitle: 'Deklarirana topologija',
        members: 'članovi',
        primary: 'primarni',
        held: 'držan na JEDNOM članu',
        form: {
          perNetworkBond: 'Bond po mreži',
          singleBond: 'Jedan pričuvni bond',
          laggBond: 'LACP bond (LAGG)',
          singlePort: 'Jedan port'
        },
        colAction: 'Radnja',
        colKind: 'Vrsta',
        colDevice: 'Device',
        colDetail: 'Detalj',
        action: {
          add: 'dodaj',
          remove: 'ukloni',
          replace: 'zamijeni'
        },
        diffEmpty: 'Nema čekajućeg diffa — primijenjeni dokument podudara se s renderom.',
        diffBlocked: 'Nema diffa: gornja odbijanja blokiraju ovaj čvor.',
        phasePlanned: 'planirano (korak 1 od 3)',
        phaseDraining: 'prazni se (korak 2 od 3)',
        probeUnobserved: 'Sonda pražnjenja: nikad prijavljena — praznina je NEPOZNATA (retire bi sada bio odbijen).',
        probeFailed: 'Sonda pražnjenja: promatranje NEUSPJELO — poznate vremenske oznake se prenose, nikad «prazno» koje nitko nije izmjerio.',
        probeActive: {
          one: 'Sonda: {n} uspostavljena veza još na staroj adresi',
          few: 'Sonda: {n} uspostavljene veze još na staroj adresi',
          other: 'Sonda: {n} uspostavljenih veza još na staroj adresi'
        },
        probeLastActive: 'posljednja aktivnost {time}',
        probeEmpty: {
          one: 'Sonda: prazno {n} minutu',
          few: 'Sonda: prazno {n} minute',
          other: 'Sonda: prazno {n} minuta'
        },
        probeEmptyUnknown: 'Sonda: prazno (otkad, nepoznato).',
        impact: '{nics} vNIC i {apps} App na ovom čvoru koriste ove mreže: {list}',
        apply: 'Primijeni na ovaj čvor',
        applyTitle: 'Primijeni derivaciju — {node}',
        applyIntro: 'Izvedena konfiguracija prepisuje mrežni dokument čvora {node} ({n} promjena) kroz ista vrata kao editor host-network — uključujući NetworkManager checkpoint i poštenu sondu. Upozorenja plana ispod putuju s činom: pročitajte ih prije potvrde.',
        applyError: 'Apply nije uspio',
        applyRefused: 'Čvor je odbio:',
        planMoved: 'Fabric se promijenio nakon ovog pregleda — NIŠTA nije primijenjeno. Plan je ponovno učitan: pogledajte ponovno i pokušajte opet.',
        retire: 'Povuci',
        retireTitle: 'Točka bez povratka — povlačenje {address}',
        restore: 'Vrati',
        restoreTip: 'Natrag na snimku prije applyja (generacija {previous}) — poništavanje u jednom koraku (H13)',
        restoreTitle: 'Vrati prethodni dokument — {node}',
        restoreIntro: 'Mrežni dokument čvora {node} vraća se na snimku snimljenu prije zadnjeg applyja (generacija {previous}), zapisanu kao generacija {next} umjesto {current}. Worker ga usklađuje kao svaki drugi dokument.',
        restoreRedo: 'Zamijenjeni dokument postaje nova snimka: ponovno vraćanje je redo.',
        restoreClosesChain: 'Snimka je ručni dokument prije derivacije: lanac se ovdje zatvara — bez daljnjeg poništavanja, čvor je ručni do sljedećeg applyja.',
        restoreConfirm: 'Vrati',
        restoreError: 'Vraćanje nije uspjelo',
        retireIntro: 'Ovo definitivno uklanja {address} ({network}) s {point}. Nakon ovog čina put natrag je OBRNUTI flip — ponovno deklariranje stare adrese kroz isti motor — nikad slijepa obnova.',
        retireOld: 'Stara adresa (uklonjena)',
        retireNew: 'Nova adresa (ostaje)',
        retireEmptyFact: 'Sonda pražnjenja javlja adresu praznom: ovo uklanjanje ne prekida nijednu promatranu vezu.',
        retireConfirm: 'Povuci adresu',
        severActiveLoss: {
          one: 'Prekini {n} uspostavljenu vezu još na staroj adresi — umire s ovim činom',
          few: 'Prekini {n} uspostavljene veze još na staroj adresi — umiru s ovim činom',
          other: 'Prekini {n} uspostavljenih veza još na staroj adresi — umiru s ovim činom'
        },
        severUnknownLoss: 'Prihvati NEPOZNATO: sonda nikad nije promatrala ovu adresu (ili promatranje ne uspijeva) — žive veze mogu biti prekinute.'
      },
      title: 'Fabric',
      createTitle: 'Stvori fabric',
      networks: 'Mreže',
      switches: 'Preklopnici',
      ports: 'Portovi',
      laggs: 'LAGG-ovi',
      subnets: 'Podmreže',
      tabOverview: 'Pregled',
      tabNetworks: 'Logičke mreže',
      tabSwitches: 'Preklopnici',
      overviewHint: 'Fabric na prvi pogled: svaka logička mreža sa svojim MTU-om i podmrežom (VLAN-ovi žive samo u mapiranjima po portu/po LAGG-u — ista mreža može putovati s različitim tagovima na različitim portovima). Fabric je registar VANJSKE infrastrukture — TVirt promatra i deklarira, nikad ne radi provisioning, i dira samo NIC-ove registrirane pod njegovom kontrolom.',
      absorptionHint: 'Svaka ovdje deklarirana podmreža IZVODI svoju stavku u IPAM registru u istom upisu — živi i umire s mrežom.',
      scopeFixedHint: 'Scope je fiksiran na korijen klastera: fizička infrastruktura je po definiciji na razini cijelog klastera.',
      networksHint: 'Svaka mreža nosi obavezni MTU (zadano 1500) i obaveznu podmrežu; pristupnik, DNS poslužitelji i statičke rute deklarirani ovdje JEDINI su IZVOR za NIC-ove poslužitelja, App i mrežne usluge.',
      switchesHint: 'Ručni registar: port je neiskorišten, mapiran (untagged promet i promet po VLAN tagu na logičke mreže) ili član LAGG-a — član ne nosi vlastita mapiranja.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Obavezno — IPAM iz njega automatski izvodi stavku registra',
      nodeAddressing: 'Adresiranje čvorova',
      nodeAddressingNone: 'Ništa — bez adrese po čvoru',
      nodeAddressingPool: 'Pool — jedna trajna adresa po posluženom čvoru',
      nodeAddressingHint: 'Uz Pool derivacija fabrica svakom posluženom čvoru dodjeljuje adresu iz raspona rezerviranih za TVirt (trajna nakon dodjele).',
      backing: 'Backing',
      gateway: 'Pristupnik',
      ranges: 'Rezervirani rasponi',
      dns: 'DNS poslužitelji (odvojeni zarezom)',
      dnsShort: 'DNS',
      singleSourceHint: 'Pristupnik, DNS i rute deklarirani ovdje jedini su izvor — NIC-ovi poslužitelja, App i mrežne usluge crpe odavde',
      routesTitle: 'Statičke rute',
      routeDestination: 'Odredište (CIDR)',
      routeVia: 'Preko (next hop)',
      portUsed: 'Iskorišten',
      vlanMappings: 'VLAN mapiranja',
      vlanTag: 'VLAN tag',
      vlanNetwork: 'Logička mreža',
      nameTaken: 'Naziv se već koristi u fabricu',
      addNetwork: 'Dodaj mrežu',
      editNetwork: 'Uredi mrežu',
      deleteNetwork: 'Ukloni mrežu',
      deleteNetworkConfirm: 'Ukloniti logičku mrežu {name} iz fabrica? Njezina izvedena podmreža u IPAM-u umire s njom (odbija se dok je koristi neka usluga ili App). Mapiranja na portovima i LAGG-ovima koja pokazuju na nju bit će uklonjena.',
      switchName: 'Preklopnik',
      portName: 'Port',
      positionHint: 'Fizički položaj (neobavezno) — isti rječnik kao kod smještaja poslužitelja; samo deklarativno',
      addSwitch: 'Dodaj preklopnik',
      editSwitch: 'Uredi preklopnik',
      deleteSwitch: 'Ukloni preklopnik',
      deleteSwitchConfirm: 'Ukloniti preklopnik {name} sa svim njegovim portovima? LAGG-ovi se sukladno skupljaju (i umiru ispod dva porta).',
      addPort: 'Dodaj port',
      editPort: 'Uredi port',
      deletePort: 'Ukloni port',
      deletePortConfirm: 'Ukloniti port {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (tag:mreža)',
      taggedShort: 'Tagged',
      portCabling: 'Kabliranje',
      portState: 'Stanje',
      stateUnused: 'neiskorišten',
      stateMapped: 'mapiran',
      laggPortGuard: 'Port koji je član LAGG-a uređuje se sa strane LAGG-a',
      laggsTitle: 'LAGG-ovi',
      laggsHint: 'LAGG je 2+ portova u LACP-u i može se protezati preko više preklopnika (MLAG, transparentno); ulaze samo neiskorišteni portovi, LAGG je površina mapiranja, a uklonjeni port vraća se u neiskorišteno.',
      addLagg: 'Dodaj LAGG',
      editLagg: 'Uredi LAGG',
      deleteLagg: 'Ukloni LAGG',
      deleteLaggConfirm: 'Ukloniti LAGG {name}? Njegovi portovi članovi vraćaju se u neiskorišteno.',
      lacpRate: 'LACP rate',
      laggPorts: 'Portovi članovi (2+)',
      laggPortsHint: 'Ulaze samo neiskorišteni portovi — najprije oslobodite mapirani port',
      noNetworks: 'Nema deklariranih logičkih mreža.',
      noSwitches: 'Nema deklariranih preklopnika.',
      noLaggs: 'Nema deklariranih LAGG-ova.',
      staleConflict: 'Drugi operater je promijenio ovaj fabric dok si ga uređivao: spremanje je odbijeno da se ne obriše njegov rad. Tvoje promjene su još uvijek ovdje, netaknute. Ažurirani fabric je već ponovno učitan: potvrdi ponovno da ih primijeniš povrh njega, ili odustani i pogledaj što se promijenilo.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Samo izvedeno: svaka podmreža nastaje iz logičke mreže fabrica ili iz overlaya — uređuje se na izvoru. Dodijeljene adrese pokazuju TKO ih drži; rasponi rezervirani za TVirt poolovi su automatske dodjele.',
      search: 'Pretraži po imenu, CIDR-u ili adresi',
      empty: 'Nema mreža — deklarirajte logičku mrežu fabrica ili overlay podmrežu: IPAM se iz njih izvodi automatski.',
      reserved: 'Rasponi rezervirani za TVirt',
      address: 'Adresa',
      origin: 'Podrijetlo',
      origin_declared: 'deklarirano',
      origin_observed: 'opaženo',
      holder: 'Nositelj',
      noAddresses: 'Nema poznatih adresa u ovoj podmreži.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Uredi na izvoru'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Grupe vatrozida',
      createTitle: 'Nova grupa vatrozida',
      editTitle: 'Uredi grupu vatrozida',
      empty: 'Još nema grupa vatrozida — stvori jednu: rječnik pravila za višekratnu uporabu, na koji se guest NIC-ovi pozivaju po imenu.',
      nameHint: 'Slova, znamenke i . - _ u sredini; jedinstveno unutar svog scopea (istoimeni se drugdje razlikuju po /scope/naziv)',
      description: 'Opis',
      descriptionHint: 'Jedan redak namjere, prikazan svugdje gdje se grupa bira',
      enforced: 'Nametnuto scopeu',
      enforcedHint: 'Isključeno: čisti rječnik — pravila vežu samo NIC-ove koji se pozivaju na grupu. Uključeno: pravila vežu svaki guest NIC s uključenim vatrozidom pod scopeom grupe, s referencom ili bez nje.',
      enforcedChip: 'Nametnuto',
      enforcedChipHint: 'Pravila vežu svaki guest NIC s uključenim vatrozidom pod scopeom grupe, s referencom ili bez nje',
      enforceWarning: 'Uključivanjem nametanja pravila pri sljedećem usklađivanju vežu SVAKI guest NIC s uključenim vatrozidom pod {scope}, i bez izričite reference — a unutar aktivnog chaina drop pretka je konačan: razine ispod ga ne otvaraju ponovno.',
      unenforceInfo: 'Uklanjanjem nametanja pravila ostaju samo na NIC-ovima koji se izričito pozivaju na grupu.',
      rules: 'Pravila',
      tabOverview: 'Pregled',
      tabRules: 'Pravila',
      orderHint: 'Redoslijed redaka JEST redoslijed vrednovanja unutar grupe: pobjeđuje prvo pravilo koje se podudara.',
      statefulHint: 'Stateful je implicitan: odgovori na dopušteni promet prolaze sami (established/related se prihvaćaju, invalid se odbacuje — ubacuje ih motor, ne pišu se ručno).',
      noRules: 'Nema pravila — rječnik u izgradnji: pozivanje na njega je dopušteno i ne proizvodi ništa.',
      addRule: 'Dodaj pravilo',
      direction: 'Smjer',
      directionIn: 'Ulazni',
      directionOut: 'Izlazni',
      action: 'Radnja',
      action_accept: 'Prihvati',
      action_drop: 'Odbaci',
      action_reject: 'Odbij',
      protocol: 'Protokol',
      protocolAny: 'Bilo koji',
      ports: 'Portovi',
      source: 'Izvor',
      dest: 'Odredište',
      comment: 'Komentar',
      addressHint: 'IPv4 CIDR ili <fabric>/<logička mreža>; prazno = bilo koja',
      moveUp: 'Pomakni gore',
      moveDown: 'Pomakni dolje',
      nicFirewall: 'Vatrozid',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Grupe vatrozida',
      nicGroupsPlaceholder: 'Odaberi grupu…',
      nicGroupsHint: 'Vidljive grupe, uključujući one nadređenih scopeova (upotrebljive prema dolje, kao tagovi)',
      nicGroupCount: { one: '{n} grupa vatrozida', few: '{n} grupe vatrozida', other: '{n} grupa vatrozida' },
      nicOff: 'Vatrozid isključen',
      pendingRestartHint: 'Izmjene vatrozida slijede model spremljeno/primijenjeno: čekaju sljedeći power cycle (PendingRestart). Grupe nametnute od nadređenih scopeova primjenjuju se kad je vatrozid NIC-a uključen.',
      appConvergeHint: 'Izmjene vatrozida primjenjuju se pri sljedećem usklađivanju kontejnera. Grupe nametnute od nadređenih scopeova primjenjuju se kad je vatrozid uključen.',
      enforcedAncestors: 'Nametnute od nadređenih scopeova',
      enforcedAncestorsHint: 'Ova se grupa primjenjuje na svaki NIC pod svojim scopeom s UKLJUČENIM vatrozidom — prekidač je glavni prekidač NIC-a (isključeno = nikakav chain, preci uključeni); unutar aktivnog chaina autoritet pretka je konačan: njegov drop se ispod ne otvara ponovno.'
    }
  }
}
